import { useTranslate } from '@ur-solutions/react-hooks'
import { ExportFleetTaxZoneCard } from '../components'
import { ExportSection } from '../components/ExportsSettings/components'

export const ExportFleetTaxZone = () => {
  const translations = useTranslate({
    fleet: 'common.fleet',
  })

  return (
    <ExportSection header={translations.fleet}>
      <ExportFleetTaxZoneCard />
    </ExportSection>
  )
}
